import React from 'react';
import { Bot, User } from 'lucide-react';
import DOMPurify from 'dompurify';

const ChatMessage = ({ message, isUser }) => {
    const formatTime = (timestamp) => {
        return new Date(timestamp).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Format message content with basic markdown-like styling
    const formatContent = (content) => {
        if (!content) return '';

        // Process the content line by line for better formatting
        const lines = content.split('\n');
        const formattedLines = lines.map((line, index) => {
            // Bold text **text**
            line = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

            // Italic text *text*
            line = line.replace(/(?<!\*)\*(?!\*)(.*?)\*(?!\*)/g, '<em>$1</em>');

            // Code inline `code`
            line = line.replace(/`(.*?)`/g, '<code class="bg-gray-100 px-1 py-0.5 rounded text-gray-800 text-xs">$1</code>');

            // Bullet points
            if (line.trim().startsWith('• ') || line.trim().startsWith('- ')) {
                line = `<span class="flex gap-2"><span class="text-black">•</span><span>${line.trim().substring(2)}</span></span>`;
            }

            // Numbered lists
            const numberedMatch = line.trim().match(/^(\d+)\.\s(.+)/);
            if (numberedMatch) {
                line = `<span class="flex gap-2"><span class="text-black font-semibold">${numberedMatch[1]}.</span><span>${numberedMatch[2]}</span></span>`;
            }

            return line;
        });

        return formattedLines.join('<br/>');
    };

    return (
        <div className={`flex gap-3 animate-fade-in-up ${isUser ? 'flex-row-reverse' : ''}`}>
            {/* Avatar */}
            <div className={`
        flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center shadow-md
        ${isUser
                    ? 'bg-gradient-to-br from-gray-600 to-gray-800'
                    : 'bg-gradient-to-br from-gray-700 to-gray-900'
                }
      `}>
                {isUser
                    ? <User className="w-4 h-4 text-white" />
                    : <Bot className="w-4 h-4 text-white" />
                }
            </div>

            {/* Message Bubble */}
            <div className={`
        max-w-[75%] rounded-2xl px-4 py-3 shadow-sm
        ${isUser
                    ? 'bg-gray-900 text-white rounded-tr-md'
                    : 'bg-white text-gray-800 rounded-tl-md border border-gray-200'
                }
      `}>
                {isUser ? (
                    <p className="text-sm whitespace-pre-wrap leading-relaxed">{message.content}</p>
                ) : (
                    <div
                        className="text-sm leading-relaxed prose prose-sm max-w-none"
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formatContent(message.content)) }}
                    />
                )}
                <p className={`text-xs mt-2 ${isUser ? 'text-gray-400' : 'text-gray-400'}`}>
                    {formatTime(message.timestamp)}
                </p>
            </div>
        </div>
    );
};

export default ChatMessage;
